export default {
  name: 'image-preview-dialog',
  props: {
    imagePreview: {
      required: true
    }
  },
  computed: {
    preview () {
      return this.imagePreview
    }
  }
}
